// Lógica pura da tela Agentes nocivos e aposentadoria especial (S-2240).
// buildRequestBody: estado da tela -> corpo camelCase do BFF.
// build*Donut: contagens do BFF -> view-models dos gráficos (donuts).
// O BFF já devolve as contagens por chave; aqui só traduzimos key -> rótulo/cor/ordem.

export interface RetirementAliquot {
  year: string;
  aliquot: string;
}

export interface AgentesFiltros {
  competency?: string | null;
  cnpjs?: string[];
  categories?: number[];
  nociveAgent?: string[];
  specialRetirement?: boolean | null;
  retirementAliquot?: RetirementAliquot[];
  onlyExposedRisks?: boolean;
  nameCpfMatriculation?: string;
  nociveAgentCodeDesc?: string;
}

export interface AgentesRequestBody {
  competency: string | null;
  cnpjs: string[];
  categories: number[];
  nociveAgent: string[];
  specialRetirement: boolean | null;
  retirementAliquot: RetirementAliquot[];
  onlyExposedRisks: boolean;
  nameCpfMatriculation: string;
  nociveAgentCodeDesc: string;
}

export function buildRequestBody(f: AgentesFiltros): AgentesRequestBody {
  return {
    competency: f.competency ?? null,
    cnpjs: f.cnpjs ?? [],
    categories: f.categories ?? [],
    nociveAgent: f.nociveAgent ?? [],
    specialRetirement: f.specialRetirement ?? null,
    retirementAliquot: f.retirementAliquot ?? [],
    onlyExposedRisks: f.onlyExposedRisks ?? false,
    nameCpfMatriculation: f.nameCpfMatriculation ?? '',
    nociveAgentCodeDesc: f.nociveAgentCodeDesc ?? '',
  };
}

// ---- Donut: categorias de agentes nocivos ----

export const AGENT_CATEGORY_LABEL: Record<string, string> = {
  nothing: 'Ausentes',
  chemical: 'Químicos',
  physical: 'Físicos',
  biological: 'Biológicos',
  others: 'Outros',
  all: 'Associação de agentes nocivos',
};
const AGENT_ORDER = ['nothing', 'chemical', 'physical', 'biological', 'others', 'all'];
const AGENT_COLORS = ['#E7E7FA', '#3CC79D', '#E5D545', '#3C73C7', '#C73C44', '#9A3CC7'];

export interface DonutVM {
  series: number[];
  labels: string[];
  colors: string[];
}

export function buildAgentesDonut(c: Record<string, number>): DonutVM {
  return {
    series: AGENT_ORDER.map((k) => c?.[k] ?? 0),
    labels: AGENT_ORDER.map((k) => AGENT_CATEGORY_LABEL[k]),
    colors: AGENT_COLORS,
  };
}

// ---- Donut: alíquota de aposentadoria especial ----

export const ALIQUOT_LABEL: Record<string, string> = {
  nothing: 'Ausente',
  '25y-6%': '25 anos - Alíquota FAE de 6%',
  '20y-9%': '20 anos - Alíquota FAE de 9%',
  '15y-12%': '15 anos - Alíquota FAE de 12%',
};
const ALIQUOT_ORDER = ['nothing', '25y-6%', '20y-9%', '15y-12%'];
const ALIQUOT_COLORS = ['#E7E7FA', '#3CC79D', '#E5D545', '#C73C44'];

export function buildAliquotDonut(c: Record<string, number>): DonutVM {
  return {
    series: ALIQUOT_ORDER.map((k) => c?.[k] ?? 0),
    labels: ALIQUOT_ORDER.map((k) => ALIQUOT_LABEL[k]),
    colors: ALIQUOT_COLORS,
  };
}

// ---- Situação do trabalhador (badge da tabela) ----

interface SituationMeta {
  label: string;
  color: string;
}

const SITUATION: Record<string, SituationMeta> = {
  active: { label: 'Ativo', color: 'green' },
  inactive: { label: 'Inativo', color: 'red' },
  terminated: { label: 'Desligado', color: 'red' },
  retired: { label: 'Aposentado', color: 'yellow' },
  vacation: { label: 'Férias', color: 'white' },
  ceded: { label: 'Cedido', color: 'brown' },
};

export function situationBadge(s?: string): SituationMeta {
  return SITUATION[s ?? ''] ?? { label: s ?? '-', color: 'grey' };
}
